
import AppSection from "./AppSection"

export default {
  components: {
    AppSection
  },
  props: {
    heading: {
      type: String,
      required: true
    },
    isHeadingLarge: {
      type: Boolean,
      default: false
    },
    isHeadingUpperCase: {
      type: Boolean,
      default: false
    },
    body: {
      type: String,
      default: null
    },
    fontColor: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: null
    },
    steps: {
      type: Array,
      required: true
    }
  },
  computed: {
    imageUrl() {
      return this.image && this.image.filename
    },
    hasBody() {
      return Boolean(this.body)
    }
  }
}
